export class Payment {
  id: number;
  uuid: string;
  relationNumber: number;
  date: Date;
  amount: number;
  amountLeft: number;
}
